import { IS_BROWSER, createSelector, debounce } from 'redux-bundler'
const getInnerWidth = () => {
  if (!IS_BROWSER) {
    return 0
  }
  return window.innerWidth
}

const getSize = size => {
  if (size < 600) {
    return 'sm'
  }
  if (size < 960) {
    return 'md'
  }
  return 'lg'
}

export default {
  name: 'ui',
  init: store => {
    const handler = debounce(() => {
      store.dispatch({ type: 'WINDOW_RESIZED', payload: getInnerWidth() })
    }, 300)
    window.addEventListener('resize', handler, { passive: true })

    store.subscribeToSelectors(['selectShowShield'], ({ showShield }) => {
      if (showShield) {
        document.body.classList.add('overflow-hidden')
      } else {
        document.body.classList.remove('overflow-hidden')
      }
    })
  },
  getReducer: () => {
    const width = getInnerWidth()
    const initialState = {
      drawerOpen: false,
      width
    }
    return (state = initialState, { type, payload }) => {
      if (type === 'WINDOW_RESIZED') {
        return Object.assign({}, state, { width: payload })
      }
      if (type === 'DRAWER_OPENED') {
        return Object.assign({}, state, { drawerOpen: true })
      }
      if (type === 'DRAWER_CLOSED') {
        return Object.assign({}, state, { drawerOpen: false })
      }
      return state
    }
  },
  doOpenDrawer: () => ({ type: 'DRAWER_OPENED' }),
  doCloseDrawer: () => ({ store }) =>
    store.selectDrawerIsOpen() && store.dispatch({ type: 'DRAWER_CLOSED' }),
  selectViewportWidth: state => state.ui.width,
  selectViewportSize: createSelector('selectViewportWidth', getSize),
  selectViewportIsLarge: createSelector(
    'selectViewportSize',
    size => size === 'lg'
  ),
  selectDrawerIsOpen: state => state.ui.drawerOpen,
  selectShowShield: createSelector(
    'selectDrawerIsOpen',
    'selectViewportIsLarge',
    (drawerIsOpen, viewportIsLarge) => Boolean(drawerIsOpen && !viewportIsLarge)
  )
}
